import { useState } from "react"
import { ItensPerUserLogged } from "../../../../../services/login/permissaoUsuarioLoado"
import { removerAcentos } from "../../../../../utils"
import { Inline } from "../../../../../Components/CustomUi/inline"
import Input from "../../../../../Components/CustomUi/input"
import ButtonCustom from "../../../../../Components/ButtonCustom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons"
import { HeaderTable } from "../../../../../Components/CustomUi/table/headerTable"
import { BodyTable } from "../../../../../Components/CustomUi/table/bodyTable"
import { Render } from "../../../../../Components/CustomUi/render"
import { RowTable } from "../../../../../Components/CustomUi/table/rowTable"
import { RowItem } from "../../../../../Components/CustomUi/table/rowItem"
import { DeleteButton } from "../../../../../Components/CustomUi/deleteButton"
import { Empty } from "antd"
import Carregando from "../../../../../Components/CustomUi/loading"

interface Props {
  loading: boolean
  list_consultoria: any[]
  abrir?: Function
  editar?: Function
  setPagination?: React.Dispatch<React.SetStateAction<number>>
  page?: number
  setPage?: React.Dispatch<React.SetStateAction<number>>
  total: number
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
}

export const TabelaConsultoria: React.FC<Props> = ({
  list_consultoria,
  loading,
  abrir,
  setPagination,
  editar,
  page,
  setPage,
  total,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
}) => {
  const [buscarTabela, setBuscarTabela] = useState('')

  function buscarFornecedores(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const tagSemAcentos = removerAcentos(String(item?.tags))
      const nomeSemAcentos = removerAcentos(String(item?.nome))

      return (
        nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        tagSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        !buscar_nome
      )
    }
  }

  return (
    <div style={{ height: 'calc(100vh - 300px)' }}>
      <Inline alignItems='center'>
        <Input
          placeholder='Buscar fornecedores/produtos e serviços'
          value={buscarTabela}
          onChange={setBuscarTabela}
        />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 515px)' },
          { valor: 'Município', width: '300px' },
          { valor: 'Ações', width: '200px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 270px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_consultoria ?? [])
            .filter(buscarFornecedores(buscarTabela))
            .map(({ cod, nome, cidade }, index) => {
              return (
                <RowTable
                  key={cod}
                  onDoubleClick={() => editar(cod)}
                  style={{marginTop: index === 0 ? '10px' : '0px'}}
                >
                  <RowItem fontSize={13} width={'calc(100% - 510px)'}>
                    {nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'300px'}>
                    {`${(cidade?.[0]?.nome) === undefined ? '' : cidade?.[0]?.nome} - ${(cidade?.[0]?.uf_sigla) === undefined ? '' : cidade?.[0]?.uf_sigla}`}
                  </RowItem>
                  <RowItem width={'210px'} gap={10}>
                    {/* <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${nome} será excluido!`}
                      deleteds={[nome]}
                      onDelete={() => {
                        
                      }}
                      disabled={fake_loading}
                      // disabledTrigger={permissao?.exclusao === 0}
                      textButtonTrigger='Excluir'
                      typeButtonTrigger='secondary'
                    /> */}
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faEdit} />}
                      onClick={() => {
                        editar(cod)
                      }}
                      // disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                    >
                      Editar
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={list_consultoria?.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando consultorias...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}
